export default __webpack_public_path__ + "static/media/youtube_icon.4affb413.png";